import Vue from 'vue'
import VueRouter from 'vue-router'
import modal from 'ant-design-vue/es/modal'
// 首页路由
import HomeRouter from './modules/home'
// 事项相关路由
import ServiceViewRouter from './modules/service-view'
// 线上预约路由
import onlineBooking from './modules/online-booking'

Vue.use(VueRouter)

const routes = [
  // 首页
  { path: '/', redirect: '/home' },
  // 指引文件页
  {
    path: '/guidelines-for-video',
    name: 'guidelines-for-video',
    component: () => import('@/components/guide/GuidelinesForVideo.vue')
  },
  ...HomeRouter,
  ...ServiceViewRouter,
  ...onlineBooking
]

// 创建路由实例
const router = new VueRouter({
  routes,
  base: process.env.BASE_URL,
  mode: 'history'
})

// 进入路由前执行
router.beforeEach((to, from, next) => {
  // 登录回来后直接放行
  if (from.path.includes('/jis-web/login')) {
    next()
    return
  }

  // 不需要登录即可进入的路由
  const routerArr = ['home', 'submit-success', 'service', 'guidelines-for-video', 'sign-view', 'upload-file-by-mobile']
  if (routerArr.includes(to.name)) {
    next()
  } else if (sessionStorage.getItem('isLogin')) {
    next()
  } else if (to.path.startsWith('http')) {
    // 外部链接，直接跳转
    window.location.href = to.path
  } else if (process.env.NODE_ENV === 'development') {
    next()
  } else if (from.path === '/') {
    next()
  } else {
    // 需要登录且获取不到用户信息，弹窗提示
    modal.info({
      title: '登录失效',
      content: '请登录账号后操作',
      // content: '你的账号登录环境存在异常，为了账号安全，本次登录失效',
      onOk() {
        if (to.name !== 'home') {
          router.push({ name: 'home' })
        }
      },
      okText: '确定'
    })
  }
})

// 路由后置守卫
router.afterEach(() => {
  window.scrollTo(0, 0)
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.scrollY = 0
})

// 导出路由器
export default router
